import defaultReducer from './defaultReducer' ;
const defaultState = { 
    isLoading: false,
    isValid: false,
    open: false, 
    header: [],
    cms: [], 
    cmsMobile: [], 
    siteController: [],
    onSave: () => {}, 
    onClose: () => {},
    onChange: () => {}
}

export default defaultReducer('NEW_PROFILE_MODAL', defaultState)
